<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close"><i class="icon-close"></i></a>
          <h3 class="modal-title">{{group.grp_name}} 群組</h3>
        </div>
        <div class="modal-body">
          <div class="button-grid p-0 four-items">
            <a class="btn btn-border-green"
            v-for="(mem, mid) in memberList" :key="`member-btn-${mid}`"
            @click="$emit('selectMem', {index: mid, csid: mem.ID})">
              <span v-text="`${mem.NAME}`"></span>({{mem.AGE}}歲)
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupMemberModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    group: {
      type: Object,
      default: () => {
        return {}
      }
    },
    memberList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    memberList () {
      this.registerHanlink()
    }
  },
  methods: {

  }
}
</script>
